import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const AllTeachersQRCode = () => {
  // Get today's date in YYYY-MM-DD format
  const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; // Format: YYYY-MM-DD

  // Define the content for the QR code
  const qrCodeContent = `Mark attendance for all teachers on ${formattedDate}`;

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold mb-4">QR Code for All Teachers</h1>
        <QRCodeSVG value={qrCodeContent} size={256} />
        <p className="mt-2">Scan this QR code to mark attendance for all teachers on {formattedDate}</p>
      </div>
    </div>
  );
};

export default AllTeachersQRCode;
